<template>
	<div id="pagepages">
		<div class="page_navigator">
			<PageTools />
		</div>

		<div id="lespages" v-if="$store.state.ordre_des_pages && $store.state.offre_ready && $store.state.offre_active.statut == 'draft'">
			<component v-for="p in orderedPages" :is="p.comp" :key="p.key" class="page" />
		</div>
		<iframe id="pdf" v-else :src="$store.state.offre_active.url_pdf_envoye"> </iframe>
	</div>
</template>
<script>
	import base from '@/libs/airtable';
	import Page1 from '../components/pages/page1';
	import Page2 from '../components/pages/page2';
	import Page3 from '../components/pages/page3';
	import Page4 from '../components/pages/page4';
	import Page5 from '../components/pages/page5';
	import Page6 from '../components/pages/page6';
	import Page7 from '../components/pages/page7';
	import Page8 from '../components/pages/page8';
	import Page9 from '../components/pages/page9';
	import Page10 from '../components/pages/page10';
	import Page11 from '../components/pages/page11';
	import Page12 from '../components/pages/page12';
	import PageTools from '../components/pages/pages_tools';
	export default {
		name: 'Pages',
		components: {
			Page1,
			Page2,
			Page3,
			Page4,
			Page5,
			Page6,
			Page7,
			Page8,
			Page9,
			Page10,
			Page11,
			Page12,
			PageTools,
		},
		data() {
			return {};
		},
		watch: {},
		computed: {
			orderedPages() {
				const cfg = this.$store.state.ordre_des_pages || {};
				// Associe la clé du store au composant
				const pages = [
					{ key: 'page1', comp: 'Page1' },
					{ key: 'page2', comp: 'Page2' },
					{ key: 'page3', comp: 'Page3' },
					{ key: 'page4', comp: 'Page4' },
					{ key: 'page5', comp: 'Page5' },
					{ key: 'page6', comp: 'Page6' },
					{ key: 'page7', comp: 'Page7' },
					{ key: 'page8', comp: 'Page8' },
					{ key: 'page9', comp: 'Page9' },
					{ key: 'page10', comp: 'Page10' },
					{ key: 'page11', comp: 'Page11' },
					{ key: 'page12', comp: 'Page12' }, // optionnelle mais incluse dans le tri
				];

				return pages
					.filter((p) => cfg[p.key]?.visible) // garde uniquement les pages visibles
					.sort((a, b) => (cfg[a.key]?.ordre ?? 999) - (cfg[b.key]?.ordre ?? 999));
			},
		},
		methods: {},
	};
</script>

<style lang="less">
	#pdf {
		right: 0;
		position: relative;
		bottom: 0;
		flex: 1;
		margin-left: 280px;
		min-height: calc(~'100vh - 80px');
	}

	#lespages {
		position: relative;
		padding: 50px 10px 50px 10px;
		flex: 1;
		margin-left: 280px;
		display: flex;
		flex-direction: column;

		.page {
			display: block;
			background-color: #fff;
			width: 1190px;
			height: 1684px;
			min-height: 1684px;
			margin-left: auto;
			margin-right: auto;
			border-radius: 4px;
			margin-bottom: 30px;
			padding: 50px;
			position: relative;
			transform-origin: center;
			box-shadow: unset !important;
			&.masked {
				display: none;
			}
			&.readyforexport {
				//transform: scale(0.5);
				&.masked {
					display: none;
				}
				.recap .masked {
					display: none !important;
				}
			}
		}
	}
</style>
